import React, { useEffect, useState, useRef } from "react";
import "./HeroSection.css";

import slide1 from "../assets/slide_1.webp";
import slide2 from "../assets/slide_2.webp";
import slide3 from "../assets/slide_3.webp";
import slide4 from "../assets/slide_4.webp";

const slides = [slide1, slide2, slide3, slide4];

const HeroSection = () => {
  const heroRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Slideshow interval
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section ref={heroRef} className="relison-hero">
      {/* Background slideshow */}
      <div className="hero-slideshow">
        {slides.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index + 1}`}
            className={`slide ${index === currentSlide ? "active" : ""}`}
          />
        ))}
        <div className="hero-overlay" />
      </div>

      {/* Right-side vertical button */}
      <div className="hero-right-button">
        <a href="/products" className="primary-btn vertical-btn">
          Explore Our Products
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
